import cn from 'classnames';

import { ComponentProps } from 'src/types/component-props';
import { CoreContactCardGridData } from 'src/types/components';

import RichText from 'components/BaseHelpers/RichText';
import Text from 'components/BaseHelpers/Text';

import ContactCard from './components/ContactCard';

import styles from './CoreContactCardGrid.module.scss';

export type CoreContactCardGridProps = ComponentProps & CoreContactCardGridData;

const CoreContactCardGrid = ({ fields }: CoreContactCardGridProps): JSX.Element => {
  const { eyebrow, heading, description } = fields.header;
  const displayHeader = !!eyebrow || !!heading || !!description;

  const customGridClass = fields.grid.length <= 3 && styles['grid--centered'];
  return (
    <section id={fields.anchorTag} className={cn(styles.main, 'spacer')}>
      <div className={cn(styles.innerWrapper, 'container', 'container--true-1440')}>
        {displayHeader && (
          <div className={styles.header}>
            {!!eyebrow && <Text tag="p" className={styles.eyebrow} field={eyebrow} />}
            {!!heading && <Text tag="h2" field={heading} className={styles.heading} />}
            {!!description && <RichText field={description} className={styles.description} />}
          </div>
        )}
        {fields.grid.length > 0 && (
          <ul className={cn(styles.grid, customGridClass)}>
            {fields.grid.map((card, index) => {
              return <ContactCard className={styles.gridItem} card={card} key={index} />;
            })}
          </ul>
        )}
      </div>
    </section>
  );
};

export default CoreContactCardGrid;
